var convert = require('./convert'),
    func = convert('isFunction', require('../isFunction'), require('./_falseOptions'));

func.placeholder = require('./placeholder');
module.exports = func;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/lodash/fp/isFunction.js
 **/